import React from "react";
import { Divider, List, ListItem, ListItemSecondaryAction, Switch } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import useStyles from "./styles";

const SkeletonContent = () => {
  const classes = useStyles();
  return (
    <List>
      {[0, 1, 2, 3, 4].map((i) => (
        <SkeletonRow key={i} classes={classes} />
      ))}
    </List>
  );
};

const SkeletonRow = ({ classes }) => {
  return (
    <>
      <ListItem>
        <div className={classes.skeletonText}>
          <Skeleton animation="wave" variant="text" height={24} width="80%" />
          <Skeleton animation="wave" variant="text" height={10} width="60%" />
        </div>
        <ListItemSecondaryAction>
          <Skeleton animation="wave">
            <Switch edge="end" />
          </Skeleton>
        </ListItemSecondaryAction>
      </ListItem>
      <Divider />
    </>
  );
};

export default SkeletonContent;
